module.exports = __webpack_public_path__ + "img/d59bce3.jpg";